import { reducer, on } from 'ts-action';
import * as ecgCountActions from '../actions/ecg-count.actions';

export const ECG_COUNT_KEY = 'ecgCount';

declare module 'react-redux' {
  interface DefaultRootState {
    counter: CounterState;
  }
}
export interface CounterState {
  counter: number;
  currentEcgId?: string;
}

const getInitialState = (): CounterState => {
  const initialState = parseInt(localStorage.getItem(ECG_COUNT_KEY) || '0', 10);
  return { counter: initialState };
};

export const ecgCounterReducer = reducer(
  getInitialState(),
  on(ecgCountActions.reset, () => {
    localStorage.setItem(ECG_COUNT_KEY, '0');
    return { counter: 0 };
  }),
  on(ecgCountActions.increment, (state, { ecgId }) => {
    const counter = state.counter + 1;
    localStorage.setItem(ECG_COUNT_KEY, counter.toString());
    return { counter, currentEcgId: ecgId };
  }),
);
